import React from 'react'
import classNames from 'classnames'

interface props {
  numStep: number
  nomStep: string
  isActive: boolean
  lastStep?: boolean
  isComplete?: boolean
  setNumStep:(val:number)=>void
}

const StepTransfert: React.FC<props> = ({ numStep, nomStep, isActive, lastStep, setNumStep }) => {
  return (

    <div className={` ${lastStep && 'w-full'} flex   items-baseline my-[43px] xl:my-10   lg:my-5  `}>
      <div className="flex w-[20px] sm:mx-2 flex-col items-center text-center mx-4 ">
        <div
        onClick={()=> {if (isActive) setNumStep(numStep-1)}}
          className={classNames(
           
            isActive ? 'bg-[#5754E5] cursor-pointer' : 'bg-[#D1D1FF] cursor-default',
            ` text-white   w-8 h-8 sm:w-6 sm:h-6 rounded-full flex items-center justify-center`,
          )}
        >
          {numStep}
        </div>
        <div className={classNames(isActive ? 'text-[#5754E5]' : 'text-[#D1D1FF]', 'sm:text-[10px] mt-2')}>
          {nomStep}
        </div>
      </div>

      {lastStep && (
        <div className={classNames(isActive ? 'bg-[#5754E5]' : 'bg-[#D1D1FF]', `rounded-xl w-full h-[2px]  `)}/>
      )}
    </div>
  )
}
export default StepTransfert
